import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Responsive,
  TextInput,
  SimpleList,
  TopToolbar,
  Pagination
} from 'react-admin';
import {
  predictiveSearchFormatter,
  predictiveSearchParser
} from '../../core/utils';
import Filter from '../../core/components/list/StyledFilter';
import ListTitleBar from '../../core/components/ListTitleBar';
import BulkActionDeleteButton from '../../core/components/BulkActionDeleteButton';
import { makeStyles } from '@material-ui/core';
import DocumentWatermarkIcon from '@material-ui/icons/BrandingWatermark';
import LinkField from '../../core/components/LinkField';
import Empty from '../../core/components/list/Empty';

const useStyles = makeStyles({
  textInput: {
    minWidth: '225px'
  },
  dataGridHead: {
    '& tr': {
      '& th:nth-of-type(1)': {
        width: '24px'
      }
    }
  },
  root: {
    marginRight: 'auto'
  }
});

const Actions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => {
  const classes = useStyles();

  return (
    <TopToolbar classes={{ root: classes.root }}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
    </TopToolbar>
  );
};

const DocumentWatermarkFilter = props => {
  const classes = useStyles();
  return (
    <Filter variant="standard" {...props}>
      <TextInput
        label="Search by Watermark Name"
        source="name"
        alwaysOn
        className={classes.textInput}
        parse={predictiveSearchParser}
        format={predictiveSearchFormatter}
        options={{ autoComplete: 'off' }}
      />
    </Filter>
  );
};

const DocumentWatermarkTitle = props => {
  return (
    <ListTitleBar
      type="Watermark Profiles"
      title="Create New Watermark Profile"
      createUrl="#/documentwatermarks/create"
      icon={<DocumentWatermarkIcon />}
      hasCreatePermission={props.hasCreatePermission}
    />
  );
};

const DocumentWatermarkList = props => {
  const classes = useStyles();
  const {
    hasCreatePermission,
    hasEditPermission,
    hasDeletePermission,
    userProfile,
    ...rest
  } = props;

  return (
    <List
      {...rest}
      sort={{ field: 'profileName', order: 'ASC' }}
      exporter={false}
      title={
        <DocumentWatermarkTitle hasCreatePermission={hasCreatePermission} />
      }
      filters={<DocumentWatermarkFilter />}
      bulkActionButtons={hasDeletePermission && <BulkActionDeleteButton />}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[20, 25, 30]} />}
      actions={<Actions />}
      empty={<Empty />}
      syncWithLocation
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.profileName}
            secondaryText={record => record.watermarkText}
            tertiaryText={() => ''}
          />
        }
        medium={
          <Datagrid
            classes={{ thead: hasDeletePermission && classes.dataGridHead }}
          >
            <LinkField source="profileName" label="Watermark Profile Name" />
            <TextField
              label="Watermark Text"
              source="watermarkText"
              sortable={false}
            />
          </Datagrid>
        }
      />
    </List>
  );
};

export default DocumentWatermarkList;
